export default "__VITE_ASSET__BN_rm0Cn__"